import * as services from './index.reexport';

import { TServices } from 'types/services';

export const servicesMock: TServices = services;
